import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import MultiPayment from "../components/multiPayment.jsx";
import Footer from "../components/footer.jsx";

function MultiPaymentPage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <MultiPayment/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default MultiPaymentPage;